import React from 'react'
import Icon from 'react-icon-base'

export default props => {
  return (
    <Icon viewBox="0 0 512 512" {...props}>
      <title id="Star-Half-Empty">{props.title || 'Star-Half-Empty'}</title>
      <g>
        <path d="M365.2 295.3l79.3-77.2-130.3-19.1-9.3-18.5-49.1-99.4v297.3l18.2 9.6 98.2 51.9-18.5-109.6-3.7-20.4 15.2-14.6zm139.5-80.8l-112.1 109.2 26.6 154.4c1 6.8.4 12.1-1.9 15.9-2.3 3.8-5.8 5.7-10.5 5.7-3.5 0-7.6-1.2-12.3-3.7l-138.6-72.9-138.7 72.9c-4.7 2.5-8.9 3.7-12.3 3.7-4.7 0-8.2-1.9-10.5-5.7-2.3-3.8-2.9-9.1-1.9-15.9l26.6-154.4-112.4-109.2c-6.6-6.6-9-12.7-7.1-18.4 1.8-5.7 7.4-9.2 16.7-10.7l155-22.5 69.5-140.5c4.1-8.4 9.2-12.7 15.1-12.7 5.8 0 10.8 4.2 15.1 12.7l69.5 140.5 155 22.5c9.3 1.4 14.8 5 16.7 10.7 1.8 5.6-.7 11.8-7.5 18.4z" />
      </g>
    </Icon>
  )
}



// WEBPACK FOOTER //
// ./client/components/icons/starHalfEmpty.js